import { render, staticRenderFns } from "./SmsResult.vue?vue&type=template&id=1ca78d50&scoped=true&"
import script from "./SmsResult.vue?vue&type=script&lang=js&"
export * from "./SmsResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca78d50",
  null
  
)

export default component.exports